import { getHandbook } from 'api/clients/HandbookClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { defaultLongCacheTime } from 'queryClient'
import { useQuery, UseQueryOptions } from 'react-query'
import { HandbookV2 } from 'types'

export const useHandbook = (key: string, reactQueryOptions: UseQueryOptions<{ handbook: HandbookV2 }> = {}) => {
  return useQuery<{ handbook: HandbookV2 }>(
    ['handbook', key],
    async () => {
      const res = await getHandbook(key)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      cacheTime: defaultLongCacheTime,
      ...reactQueryOptions,
    },
  )
}
